class EditableForm {
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._trigger = this._element.querySelector(
            `${this._options.editTrigger}`
        );
        this._inputs = Array.from(this._element.querySelectorAll("input"));
        this._init();
    }

    _init() {
        this._toggleReadOnly();
        this._trigger.addEventListener("click", e => this._onEdit(e));
    }

    _onEdit(e) {
        e && e.preventDefault();
        this._element.classList.add("form--editable");
        this._toggleReadOnly();
    }

    _toggleReadOnly() {
        this._inputs.forEach(input => (input.readOnly = !input.readOnly));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    for (let element of document.querySelectorAll(
        `[data-module="EditableForm"]`
    )) {
        const options = JSON.parse(JSON.stringify(element.dataset));
        new EditableForm(element, options);
        element.setAttribute("data-initialized", "");
    }
});
